module.exports = __webpack_public_path__ + "static/media/Audio.5f326586.jpg";